export interface MountOnceGuard {
  didMount: (callback: () => void) => void;
  willUnmount: (callback: () => void) => void;
}

// StrictMode の開発時二重マウント (componentDidMount→componentWillUnmount→componentDidMount) でも
// componentDidMount 本体と componentWillUnmount 側の後始末処理が二重に走らないようにするためのガード。
// クラスコンポーネント用 (関数コンポーネントは hooks/useMountOnce を使う)
export const createMountOnceGuard = (): MountOnceGuard => {
  let hasMountedOnce = false;
  let isMounted = false;

  return {
    didMount: callback => {
      isMounted = true;
      if (hasMountedOnce) return;
      hasMountedOnce = true;
      callback();
    },
    willUnmount: callback => {
      isMounted = false;

      // StrictMode の疑似アンマウント対策は開発時のみ必要。本番ビルドでは
      // StrictMode の二重マウントが発生しないため、従来通り同期実行する
      if (MODE === "production") {
        callback();
        return;
      }

      // StrictMode の疑似アンマウントは同じ tick 内で componentDidMount が再度呼ばれるため、
      // 本当にアンマウントされたままかどうかをマイクロタスクまで待って判定する。
      // (ここで即実行すると、疑似アンマウントで resetAll 等が走った直後に
      //  2回目の componentDidMount がガードでスキップされ、復元したデータが失われる)
      Promise.resolve().then(() => {
        if (!isMounted) callback();
      });
    }
  };
};
